export default "__VITE_ASSET__DsS_3xhJ__"